import { MultiPolygon, Polygon, MultiLineString } from 'geojson';
import { GeoJSONType } from '@/types/geojson';

export interface ScoutLocation {
  _id: string;
  geojson: Polygon | MultiPolygon;
  segments?: MultiLineString;
  name: string;
  description?: string;
  lastSeen?: string;
  lastViewed?: string;
  bursts?: Burst[];
  jobIds?: string[];
}

// TODO: separate this from ScoutLocation once it's been created on the BE.
export interface AlmanacLocation extends ScoutLocation {
  segments: MultiLineString;
}

export interface FilesWithLocations {
  [key: string]: {
    file: File;
    locations: ScoutLocation[];
  };
}

export interface ScoutPayload {
  name: string;
  geojson: Polygon | MultiPolygon;
  description?: string;
}

export interface Frame {
  url: string;
  timestamp: string;
  idx: number;
  sequence: string;
  position: {
    lat: number;
    lon: number;
    latRef: string;
    lonRef: string;
    mountPosition: 'front' | 'right' | 'left' | 'back';
    gdop: number;
    hdop: number;
    pdop: number;
    eph: number;
  };
  bearing?: number;
}

export interface CSVLocation {
  type: GeoJSONType;
  coordinates: string;
  name?: string;
  description?: string;
}

export enum Filters {
  ALL = 'All',
  SEEN_24H = 'Last 24 Hours',
  SEEN_3_DAYS = 'Last 3 Days',
  SEEN_7_DAYS = 'Last 7 Days',
  SEEN_14_DAYS = 'Last 14 Days',
  NOT_SEEN = 'Not seen',
}

export type ScoutErrorType = 'imagery' | 'mapCredits' | 'unknown';

export interface Burst {
  status: string;
  validUntil: string;
  trackedLocation: string;
}

export enum BurstStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  REFUNDED = 'refunded',
}
